module.exports = __webpack_public_path__ + "static/media/profile_myprofile.3344adca.svg";